import * as PIXI from "../../src/core/PIXI";
export default class Background
{
    app: PIXI.Application;
    
    pad: number = 30;

    gameOver: boolean;
    animations: boolean;
    roundStartedAt: number;

    godrays: PIXI.Sprite;

    angleStartedAt: number;

    dotsVr: PIXI.Container;
    dotsHr: PIXI.Container;
    graph: PIXI.Graphics;

    pHr: number;
    pHrStart: number;
    pVr: number;
    pVrStart: number;
    dotHrStep: number;
    dotVrStep: number;

    constructor(app: PIXI.Application)
    {
        this.app = app;

        this.tickerUpdate = this.tickerUpdate.bind(this);

        this.gameOver = true;
        this.animations = false;

        this.pHr = 0.99;
        this.pHrStart = 0.99;
        this.pVr = 0;
        this.pVrStart = 0;

        this.createBackground();
        this.createGraph();
        
        this.onResize();
        
        requestAnimationFrame(this.tickerUpdate);
    }


    createGraph()
    {
        this.dotsHr = new PIXI.Container();
        this.dotsHr.visible = false;
        this.app.stage.addChild(this.dotsHr);

        for (let i = 0; i < 10; i++)
        {
            const dot = new PIXI.Graphics();
            dot.beginFill(0xffffff);
            dot.drawCircle(0, 0, 2);
            dot.endFill();
            this.dotsHr.addChild(dot);
        }

        this.dotsVr = new PIXI.Container();
        this.dotsVr.visible = false;
        this.app.stage.addChild(this.dotsVr);

        for (let i = 0; i < 10; i++)
        {
            const dot = new PIXI.Graphics();
            dot.beginFill(0x1197d6);
            dot.drawCircle(0, 0, 2);
            dot.endFill();
            this.dotsVr.addChild(dot);
        }

        this.graph = new PIXI.Graphics();
        this.graph.visible = false;
        this.app.stage.addChild(this.graph);
    }


    onToggleAnimation(animations: boolean)
    {
        this.animations = animations;
        this.graph.visible = animations && !this.gameOver;
        this.dotsHr.visible = animations && !this.gameOver;
        this.dotsVr.visible = animations && !this.gameOver;
    }


    tickerUpdate()
    {
        if (!this.gameOver)
        {
            if (this.animations)
            {
                const s = Math.PI * .5 / 9000;
                this.godrays.rotation = this.angleStartedAt + (performance.now() - this.roundStartedAt) * s;
            }

            const time = Math.max(0, performance.now() - this.roundStartedAt - 8000);

            this.pHr = (this.pHrStart + time / 6500) % 1;
            this.dotsHr.x = this.pad + this.dotHrStep * (1.00 - this.pHr);

            this.pVr = (this.pVrStart + time / 3500) % 1;
            this.dotsVr.y = this.dotVrStep * this.pVr;
        }

        requestAnimationFrame(this.tickerUpdate);
    }


    startRound()
    {
        this.gameOver = false;

        this.roundStartedAt = performance.now();
        this.angleStartedAt = this.godrays.rotation;
        this.pHrStart = this.pHr;
        this.pVrStart = this.pVr;

        this.graph.visible = this.animations;
        this.dotsHr.visible = this.animations;
        this.dotsVr.visible = this.animations;
    }


    stopRound()
    {
        this.gameOver = true;

        this.graph.visible = false;
        this.dotsHr.visible = false;
        this.dotsVr.visible = false;
    }


    reset()
    {
        this.gameOver = true;

        this.graph.visible = false;
        this.dotsHr.visible = false;
        this.dotsVr.visible = false;

        this.roundStartedAt = performance.now();
    }


    createBackground()
    {
        this.godrays = new PIXI.Sprite(PIXI.Resources.textures["godrays"]);
        this.godrays.anchor.set(0.5);
        this.app.stage.addChild(this.godrays);
    }


    onResize()
    {
        const _w = this.app.width;
        const _h = this.app.height;

        const w = Math.sqrt(_w * _w + _h * _h);
        const scale = w / (this.godrays.texture.orig.width * .5)
        this.godrays.scale.set(scale);

        this.godrays.y = _h;

        this.dotHrStep = (_w - this.pad) / 9;
        this.dotsHr.children.forEach((dot, index) => {
            dot.x = this.dotHrStep * index;
        });
        
        this.dotVrStep = (_h - this.pad) / 10;
        this.dotsVr.children.forEach((dot, index) => {
            dot.y = this.dotVrStep * index;
        });

        this.dotsHr.position.set(
            this.pad,
            _h - this.pad * .5
        );

        this.dotsVr.position.set(
            this.pad * .5,
            0
        );

        this.graph.clear();
        this.graph.lineStyle({
            color: 0x2a2b2e,
            width: 2
        });
        this.graph.moveTo(this.pad, 0);
        this.graph.lineTo(this.pad, _h - this.pad);
        this.graph.lineTo(_w, _h - this.pad);

        this.tickerUpdate();
    }

}


export namespace Background
{

    export interface Props
    {

    }

}